import $ from 'jquery';
import { DevelopmentRegisterConfig } from "../config/dev/env"

function Retryer(maxTimes) {
    const MAX_TIMES = Number(maxTimes) || 2;
    let TRIEDTIMES = 0;

    this.retry = () => {
        if (TRIEDTIMES >= MAX_TIMES) {
            return false;
        }
        else {
            TRIEDTIMES++;
            return true;
        }
    };
};

export function httpCall({ url = '/', method = 'POST', data = null, async = true, headers, withCredentials = false, onSuccess, onError, takeHeader = '' }) {
    try {
        let LogObj = {
            feature: url,
            logdetailsRequest: `RequestHeader:\n${getString(headers)}\n$>RequestBody:\n${getString(data)}`
        };

        return new Promise((res, rej) => {
            let xhr = new XMLHttpRequest();
            xhr.open(method, url, async);
            xhr.withCredentials = withCredentials;
            let RETRYER = new Retryer(2);

            if (headers && typeof headers === 'object') {
                for (let k in headers) {
                    xhr.setRequestHeader(k, headers[k]);
                }
            }

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    LogObj.logdetailsResponse = `ResponseStatus:\n${xhr.statusText}\n$>ResponseBody:\n${xhr.responseText}`;
                    MyLogger.pushLog(LogObj);
                    if (xhr.status === 200) {
                        if (onSuccess) {
                            onSuccess(xhr.responseText);
                        }
                        res(createResponse(xhr.responseText, takeHeader && xhr.getResponseHeader(takeHeader)));
                    }
                    else if (xhr.status >= 300) {
                        if (RETRYER && RETRYER.retry()) {
                            xhr.open(method, url, async);
                            xhr.withCredentials = withCredentials;
                            xhr.send(data);
                        } else {
                            if (onError) {
                                onError(xhr.statusText);
                            }
                            rej(createResponse(null, null, `${xhr.status} ${xhr.statusText}`));
                        }
                    }
                }
            }
            xhr.onerror = function (err) {
                LogObj.logdetailsResponse = `ResponseStatus:\n${xhr.statusText}\n$>ErrorDetails:\n${getString(err)}`;
                MyLogger.pushLog(LogObj);
                rej(createResponse(null, null, `error occured.\n${xhr.status} ${xhr.statusText}`));
            }

            xhr.send(data);
        });
    }
    catch (ex) {
        console.error(ex);
        MyLogger.pushLog({
            feature: url,
            logdetailsRequest: `RequestHeader:\n${getString(headers)}\n$>RequestBody:\n${getString(data)}`,
            logdetails: `ErrorDetails:\n${getString(ex)}`
        });
    }
}

function createResponse(data, header, error) {
    return {
        data: data
        , header: header
        , error: error
    };
}

function getString(data) {
    if (data && (typeof data === 'object' || typeof data === 'function')) {
        let DateStr;
        try {
            DateStr = JSON.stringify(data);
            return DateStr;
        }
        catch (ex) {
            DateStr = 'failed to stringify this value.';
            return DateStr;
        }
    }
    else {
        return data;
    }
}

export function ajaxCall(ajaxSettings, noLog) {
    const LogObj = {
        feature: ajaxSettings.url,
        logdetailsRequest: `AjaxSettings:\n${getString(ajaxSettings)}`
    };
    // debugger;
    return $.ajax(ajaxSettings).always((P1, P2, P3) => {
        switch (P2) {
            case "error": {
                //P1 is the XHR ,P3 is the statusText
                LogObj['logdetailsResponse'] = `ResponseStatus:\n${P1.status} ${P2}\n$>ErrorDetails:\n${P3}`;
                break;
            }
            case "success": {
                //P1 is the response, P3 is the XHR
                LogObj['logdetailsResponse'] = `ResponseStatus:\n${P3.status} ${P2}\n$>ResponseBody:\n${getString(P1)}`;
                break;
            }
            default: {
                LogObj['logdetailsResponse'] = `ResponseStatus:\n${P1.status} ${P2}\n$>EventDetails:\n${getString(P3)}`;
                //
            }
        }
        if (!noLog) {
            MyLogger.pushLog(LogObj);
        }
    });
}

export function IsNetWorkSuccess(response) {
    let jsonData = JSON.parse(response);

    if (jsonData) {
        if (jsonData.responseType) {
            if (jsonData.responseType === "S") return true;
        }
    }

    return false;
}

export const MyLogger = (function () {
    let pushLog = null;
    let getLog = null;
    return {
        initLogger: (logger) => {
            pushLog = logger.pushLog;
            getLog = logger.getLog;
        },
        pushLog: (log) => {
            if (typeof pushLog === 'function') {
                pushLog(log);
            }
        },
        getLog: (date) => {
            if (typeof getLog === 'function') {
                return getLog(date);
            }
            else {
                return Promise.reject('function undefined');
            }
        }
    }
})();

function getConfigPath() {
    console.log("MFE href :" + window.location.href);
    const IsUnderTest = /\/mfe-cfo-service-request\//i.test(window.location.href);
    const Result = { path: "" };

    Result.path = IsUnderTest ? "/digital/web/hk/mfe-cfo-service-request" : "/digital/web/hk/business-banking/portal";

    return Result;
}

export async function getMFERegisterEndpoint() {
    if (process.env.NODE_ENV === "development") {
        const ConfigPath = getConfigPath();
        console.log("get configuration files path :" + ConfigPath.path);
        return Promise.resolve(DevelopmentRegisterConfig);
    } else {
        const ConfigPath = getConfigPath();
        console.log("get configuration files path :" + ConfigPath.path);
        try {
            const response = await fetch(
                ConfigPath.path + "/config/env.json"
            );

            if (response.ok) {
                const jsonVal = await response.json();
                return Promise.resolve(jsonVal);
            } else {
                const response = await fetch("/config/env.json");

                if (response.ok) {
                    const jsonVal = await response.json();
                    return Promise.resolve(jsonVal);
                } else {
                    return Promise.reject(response.statusText);
                }
            }
        } catch (e) {
            console.log("Error!", e);
        }
    }
}